import { useState } from 'react';

export default function NewUserModal({ show, onClose, onCreateUser, onShowPromo, onShowAuth }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [birthday, setBirthday] = useState('');
  const [saving, setSaving] = useState(false);

  if (!show) return null;

  async function handleCreate() {
    if (!name.trim() || !email.trim()) {
      alert("Please enter both a name and an email.");
      return;
    }
    setSaving(true);
    try {
      await onCreateUser(name.trim(), email.trim(), birthday);
      setName('');
      setEmail('');
      setBirthday('');
      onClose();
      onShowPromo();
    } catch (error) {
      console.error("Error creating user profile: ", error);
      alert("Failed to create profile. Please try again.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="blurred-app-state">
      <div className="modal-card">
        <button className="sidebar-close-btn" onClick={onClose}>&times;</button>
        <h2>Create Player Profile</h2>
        <div className="input-group">
          <label className="input-label">Name</label>
          <input type="text" className="name-input" placeholder="Enter your name"
            value={name} onChange={e => setName(e.target.value)} />
        </div>
        <div className="input-group">
          <label className="input-label">Email</label>
          <input type="email" className="name-input" placeholder="Enter your email"
            value={email} onChange={e => setEmail(e.target.value)} />
        </div>
        <div className="input-group">
          <label className="input-label">Birthday</label>
          <input type="date" className="name-input"
            value={birthday} onChange={e => setBirthday(e.target.value)} />
        </div>
        <button className="btn-bank" style={{ marginTop: 20 }} onClick={handleCreate} disabled={saving}>
          {saving ? 'Saving...' : 'Create Profile'}
        </button>
        {onShowAuth && (
          <button className="btn-link" style={{ marginTop: 12, fontSize: '0.8rem' }}
            onClick={() => { onClose(); onShowAuth(); }}>
            Want to save your stats? Create an account
          </button>
        )}
      </div>
    </div>
  );
}
